import React from 'react';
import ContentLoader from 'react-content-loader';

const Skeleton = () => (
  <ContentLoader
    className="pizza-block"
    speed={2}
    width={280}
    height={500}
    viewBox="0 0 280 500"
    backgroundColor="#f3f3f3"
    foregroundColor="#ecebeb">
    <circle cx="120" cy="161" r="120" />
    <rect x="9" y="304" rx="10" ry="10" width="219" height="15" />
    <rect x="12" y="332" rx="10" ry="10" width="218" height="59" />
    <rect x="13" y="406" rx="10" ry="10" width="70" height="22" />
    <rect x="118" y="401" rx="20" ry="20" width="112" height="34" />
  </ContentLoader>
);

export default Skeleton;
